import { render, staticRenderFns } from "./add-edit-template.vue?vue&type=template&id=a3b9e954&scoped=true"
import script from "./add-edit-template.vue?vue&type=script&lang=js"
export * from "./add-edit-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b9e954",
  null
  
)

export default component.exports